import React, { createContext, useState } from "react";

import { Account } from "../models/account";
import { Status } from "../util/enums";
import { useAppState } from "./StateContext";

interface AccountContextProps {
  account: Account;
  setAccount: (value: Account) => void;
  handleUpdateAccount: (attribute: string, value: any) => void;
}

const AccountContext = createContext<AccountContextProps>({} as AccountContextProps);

interface AccountProviderProps {
  children: React.ReactChild;
}

const AccountProvider = ({ children }: AccountProviderProps) => {
  const { currentUser } = useAppState();

  const [account, setAccount] = useState<Account>({
    status: Status.ACTIVE,
    companyId: currentUser?.companyId,
  } as Account);

  const handleUpdateAccount = (attribute: string, value: any) => {
    setAccount((state) => ({
      ...state,
      [attribute]: value,
    }));
  };

  return (
    <AccountContext.Provider value={{ account, setAccount, handleUpdateAccount }}>
      {children}
    </AccountContext.Provider>
  );
};

export { AccountContext, AccountProvider };
